
import './js/localjs.js';

// Initialize Homepage Widgets if is required
if (window.location.pathname === '/') {
    $(document).ready(function () {
    });

};
